var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustration500(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 264,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M200 264c110.457 0 200-6.359 200-14.202 0-7.844-89.543-14.203-200-14.203S0 241.954 0 249.798C0 257.641 89.543 264 200 264Z",
    fill: "#00274D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M343.685 0H57.025v186.665h286.66V0Z",
    fill: "#00274D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m178.693 165.337-10.888 69.318h72.616l-16.693-69.318h-45.035Z",
    fill: "#C2CBD1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M343.685 144.022H57.025v42.643h286.66v-42.643Z",
    fill: "#D4DBE0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M201.952 174.33c6.356 0 11.509-5.164 11.509-11.534 0-6.37-5.153-11.534-11.509-11.534-6.356 0-11.509 5.164-11.509 11.534 0 6.37 5.153 11.534 11.509 11.534Z",
    fill: "#EAEDF0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M253.375 222.511H151.239v22.281h102.136v-22.281Z",
    fill: "#D4DBE0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.335 23.652a5.025 5.025 0 0 0 5.019-5.03 5.025 5.025 0 0 0-5.02-5.03 5.025 5.025 0 0 0-5.019 5.03 5.025 5.025 0 0 0 5.02 5.03Z",
    fill: "#54708C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.253 23.652a5.025 5.025 0 0 0 5.02-5.03 5.025 5.025 0 0 0-5.02-5.03 5.025 5.025 0 0 0-5.02 5.03 5.025 5.025 0 0 0 5.02 5.03Z",
    fill: "#016AD4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M109.322 23.652a5.025 5.025 0 0 0 5.02-5.03 5.025 5.025 0 0 0-5.02-5.03 5.025 5.025 0 0 0-5.019 5.03 5.025 5.025 0 0 0 5.019 5.03Z",
    fill: "#009D93"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M55.34 187.185H44.59v60.947h10.75v-60.947ZM113.404 187.185h-10.749v60.947h10.749v-60.947Z",
    fill: "#016AD4"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M55.34 187.185H44.59v60.947h10.75v-60.947ZM113.404 187.185h-10.749v60.947h10.749v-60.947Z",
    fill: "#000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M126.155 158.491H31.878v33.331h94.277v-33.331Z",
    fill: "#016AD4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m36.656 158.491 11.269 33.319h15.59L50.7 158.491H36.656ZM65.517 158.491l11.269 33.319h15.577l-12.802-33.319H65.517ZM94.277 158.491l11.268 33.319h15.591l-12.815-33.319H94.277Z",
    fill: "#00274D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M126.155 204.436H31.878v15.624h94.277v-15.624Z",
    fill: "#016AD4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M126.155 204.436H31.878v15.624h94.277v-15.624Z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m200.494 37.942-52.791 81.03h105.57l-52.779-81.03Z",
    fill: "#FFC248"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M203.815 68.086h-7.503v24.363h7.503V68.086ZM203.815 97.2h-7.503v7.52h7.503V97.2Z",
    fill: "#00274D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m305.14 244.792 15.514-71.134a3.173 3.173 0 0 1 3.086-2.457c.716 0 1.411.243 1.971.689.56.446.954 1.069 1.116 1.768l16.858 72.405-38.545-1.271Z",
    fill: "#016AD4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M342.823 237.92h-37.24a5.608 5.608 0 0 0-5.602 5.614v.699a5.608 5.608 0 0 0 5.602 5.614h37.24a5.608 5.608 0 0 0 5.602-5.614v-.699a5.608 5.608 0 0 0-5.602-5.614Z",
    fill: "#016AD4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M342.823 237.92h-37.24a5.608 5.608 0 0 0-5.602 5.614v.699a5.608 5.608 0 0 0 5.602 5.614h37.24a5.608 5.608 0 0 0 5.602-5.614v-.699a5.608 5.608 0 0 0-5.602-5.614Z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "m314.899 200.002 16.541-6.643 4.83 20.731-26.01 7.202 4.639-21.29Z",
    fill: "#000"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M308.093 251.004s7.047-10.163-3.46-12.957c-10.508-2.795 2.535-16.514-7.25-18.266-9.786-1.753-8.15 12.702-8.15 12.702s-6.756-5.83-11.408-.927c-4.652 4.903 1.863 10.276 1.863 10.276s-9.405 3.252-3.536 9.21l31.941-.038Z",
    fill: "#D4DBE0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M293.973 252.35s4.474-7.622 11.065-6.72c6.591.902 5.894 6.72 5.894 6.72h-16.959Z",
    fill: "#C2CBD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration500);
export default __webpack_public_path__ + "static/media/illustration500.a7e280853326b82010302e5fbebea073.svg";
export { ForwardRef as ReactComponent };